import { render, staticRenderFns } from "./CurrentAgePercentage.vue?vue&type=template&id=8b5e41f0&scoped=true"
import script from "./CurrentAgePercentage.vue?vue&type=script&lang=ts"
export * from "./CurrentAgePercentage.vue?vue&type=script&lang=ts"
import style0 from "./CurrentAgePercentage.vue?vue&type=style&index=0&id=8b5e41f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5e41f0",
  null
  
)

export default component.exports